document.addEventListener('DOMContentLoaded', () => {
  const filterButton = document.querySelector('.filters-button-toggle');
  const filterDrawer = document.querySelector('.filters-drawer');
  const closeButton = document.querySelector('.header__icon--filters-close');
  const productsContainer = document.querySelector('.main-collection__products');
  const applyFiltersButton = document.querySelector('.filters-drawer__apply-btn');
  const resetFiltersButton = document.querySelector('.filters-drawer__reset-btn');
  const filterForm = document.getElementById('filters-drawer-form');

  if (!filterButton || !filterDrawer) return;

  // Toggle filter drawer when button is clicked
  filterButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.classList.toggle('filters-drawer-is-open');
    filterButton.setAttribute('aria-expanded', document.body.classList.contains('filters-drawer-is-open'));
  });

  // Close filter drawer when close button is clicked
  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('filters-drawer-is-open');
      filterButton.setAttribute('aria-expanded', 'false');
    });
  }

  // Apply filters button closes the drawer
  if (applyFiltersButton) {
    applyFiltersButton.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('filters-drawer-is-open');
      filterButton.setAttribute('aria-expanded', 'false');
    });
  }

  // Close drawer on Escape key
  document.addEventListener('keydown', (e) => {
    if (document.body.classList.contains('filters-drawer-is-open') && e.key === 'Escape') {
      document.body.classList.remove('filters-drawer-is-open');
      filterButton.setAttribute('aria-expanded', 'false');
    }
  });

  // Close drawer when clicking outside
  document.addEventListener('click', (e) => {
    if (document.body.classList.contains('filters-drawer-is-open')) {
      if (!filterDrawer.contains(e.target) && !filterButton.contains(e.target)) {
        document.body.classList.remove('filters-drawer-is-open');
        filterButton.setAttribute('aria-expanded', 'false');
      }
    }
  });

  if (!filterForm) return;

  // Initialize accordion functionality for fieldsets
  const fieldsets = filterForm.querySelectorAll('fieldset');
  fieldsets.forEach(fieldset => {
    const legend = fieldset.querySelector('legend');
    if (legend) {
      legend.addEventListener('click', (e) => {
        e.preventDefault();
        fieldset.classList.toggle('collapsed');
      });
    }
  });

  // Listen to filter input changes and trigger filtering
  filterForm.addEventListener('change', () => {
    handleProductFilter();
    updateActiveFilterCount();
  });

  // Listen to price input changes (for number inputs)
  filterForm.addEventListener('input', (e) => {
    if (e.target.matches('.price-input input, .range-input input')) {
      updateActiveFilterCount();
    }
  });

  // Collect the selected filter values
  function getSelectedFilters() {
    const filterData = {};
    const formData = new FormData(filterForm);
    for (const [key, value] of formData.entries()) {
      if (!filterData[key]) {
        filterData[key] = [];
      }
      filterData[key].push(value);
    }
    return filterData;
  }

  function normalizeFilterParamName(name) {
    return name.replace(/^filter-v-option-/, 'filter.v.option.');
  }

  function valuesMatch(a, b) {
    return decodeURIComponent(a || '').toLowerCase() === decodeURIComponent(b || '').toLowerCase();
  }

  // Restore selected filters from the URL on reload/back/forward.
  function syncFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (!params.toString()) return;

    filterForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });

    params.forEach((value, key) => {
      const normalizedKey = normalizeFilterParamName(key);

      if (normalizedKey === 'filter.v.availability') {
        const availabilityValue = value === '1' ? 'in-stock' : value === '0' ? 'out-of-stock' : value;
        filterForm.querySelectorAll('input[name="availability"]').forEach(input => {
          if (valuesMatch(input.value, availabilityValue)) input.checked = true;
        });
      }

      if (normalizedKey === 'filter.p.product_type') {
        filterForm.querySelectorAll('input[name="product_type"]').forEach(input => {
          if (valuesMatch(input.value, value)) input.checked = true;
        });
      }

      if (normalizedKey === 'filter.p.vendor') {
        filterForm.querySelectorAll('input[name="vendor"]').forEach(input => {
          if (valuesMatch(input.value, value)) input.checked = true;
        });
      }

      if (normalizedKey.startsWith('filter.v.option.')) {
        filterForm.querySelectorAll('input[name="color"]').forEach(input => {
          const inputParam = normalizeFilterParamName(input.dataset.filterParam || 'filter.v.option.color');
          if (inputParam === normalizedKey && valuesMatch(input.value, value)) {
            input.checked = true;
          }
        });
      }
    });
  }

  // Build a query string for filters
  function buildFilterQuery(filterData) {
    const params = [];
    const isSearchPage = document.body.classList.contains('template-search');

    function addParam(name, value) {
      params.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`);
    }

    if (isSearchPage) {
      const urlParams = new URLSearchParams(window.location.search);
      const searchInput = document.querySelector('#Search2');
      const searchTerm = searchInput?.value || urlParams.get('q');

      if (searchTerm) {
        addParam('q', searchTerm);
        addParam('type', urlParams.get('type') || 'product');
        addParam('options[prefix]', urlParams.get('options[prefix]') || 'last');
      }
    }

    // Availability
    if (filterData['availability']) {
      filterData['availability'].forEach(val => {
        if (val === 'in-stock') addParam('filter.v.availability', '1');
        if (val === 'out-of-stock') addParam('filter.v.availability', '0');
      });
    }

    // Product type
    if (filterData['product_type'] && filterData['product_type'].length > 0) {
      filterData['product_type'].forEach(type => {
        addParam('filter.p.product_type', type);
      });
    }

    // Colour (variant option)
    if (filterData['color']) {
      const selectedColorInputs = filterForm.querySelectorAll('input[name="color"]:checked');
      selectedColorInputs.forEach(input => {
        const filterParam = input.dataset.filterParam || 'filter.v.option.color';
        addParam(filterParam, input.value);
      });
    }

    // Brand (vendor)
    if (filterData['vendor'] && filterData['vendor'].length > 0) {
      filterData['vendor'].forEach(vendor => {
        addParam('filter.p.vendor', vendor);
      });
    }

    // Price range
    if (filterData['filter.v.price.gte'] && filterData['filter.v.price.gte'].length > 0) {
      const minPrice = filterData['filter.v.price.gte'][0];
      if (minPrice && parseInt(minPrice) > 0) {
        addParam('filter.v.price.gte', minPrice);
      }
    }
    if (filterData['filter.v.price.lte'] && filterData['filter.v.price.lte'].length > 0) {
      const maxPrice = filterData['filter.v.price.lte'][0];
      const maxInput = filterForm.querySelector('.input-max');
      const defaultMax = maxInput ? maxInput.getAttribute('max') : '10000';
      if (maxPrice && maxPrice !== defaultMax) {
        addParam('filter.v.price.lte', maxPrice);
      }
    }

    return params.join('&');
  }

  // Handle filter changes
  function handleProductFilter() {
    const filterData = getSelectedFilters();
    const paramString = buildFilterQuery(filterData);

    const url = new URL(window.location.href);
    url.search = paramString ? '?' + paramString : '';

    window.history.pushState({}, '', url.toString());
    fetchFilteredResults(url.toString());
  }

  // Apply client-side filtering fallback
  function applyClientSideFilters() {
    const selectedProductTypes = Array.from(
      filterForm.querySelectorAll('input[name="product_type"]:checked')
    ).map(cb => cb.value);

    const selectedColors = Array.from(
      filterForm.querySelectorAll('input[name="color"]:checked')
    ).map(cb => cb.value.toLowerCase());

    const selectedVendors = Array.from(
      filterForm.querySelectorAll('input[name="vendor"]:checked')
    ).map(cb => cb.value);

    const productBlocks = document.querySelectorAll('.main-collection__products .product-card');
    let visibleCount = 0;

    productBlocks.forEach(block => {
      let matchesType = true;
      let matchesColor = true;
      let matchesVendor = true;

      if (selectedProductTypes.length > 0) {
        const productType = block.getAttribute('data-product-type');
        matchesType = productType && selectedProductTypes.includes(productType);
      }

      if (selectedColors.length > 0) {
        const productColors = block.getAttribute('data-product-colors');
        if (productColors) {
          const colorsArray = productColors.split(',').map(c => c.trim().toLowerCase());
          matchesColor = selectedColors.some(sc => colorsArray.includes(sc));
        } else {
          matchesColor = false;
        }
      }

      if (selectedVendors.length > 0) {
        const productVendor = block.getAttribute('data-product-vendor');
        matchesVendor = productVendor && selectedVendors.includes(productVendor);
      }

      if (matchesType && matchesColor && matchesVendor) {
        block.style.display = '';
        visibleCount++;
      } else {
        block.style.display = 'none';
      }
    });

    syncPaginationWithClientFilter({
      active: selectedProductTypes.length > 0 || selectedColors.length > 0 || selectedVendors.length > 0,
      hiddenCount: productBlocks.length - visibleCount
    });

    // Handle empty state message
    const emptyMessage = document.querySelector('.main-collection h5.align-centre');
    if (visibleCount === 0 && productBlocks.length > 0) {
      if (!emptyMessage) {
        const container = document.querySelector('.main-collection .container');
        if (container) {
          const noResultsText = filterDrawer?.dataset.noResultsText || 'No products match your filters';
          const noMatches = document.createElement('h5');
          noMatches.className = 'align-centre fully-spaced-row';
          noMatches.textContent = noResultsText;
          container.appendChild(noMatches);
        }
      }
    } else if (emptyMessage && visibleCount > 0) {
      emptyMessage.remove();
    }
  }

  function syncPaginationWithClientFilter({ active, hiddenCount }) {
    const pagination = document.querySelector('.main-collection__pagination');
    if (!pagination) return;

    pagination.hidden = active && hiddenCount > 0;
  }

  // Fetch filtered products via AJAX
  function fetchFilteredResults(url) {
    if (productsContainer) {
      productsContainer.classList.add('loading');
    }

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newList = doc.querySelector('.main-collection__products');
        const currentList = document.querySelector('.main-collection__products');

        if (newList && currentList) {
          currentList.replaceWith(newList);
          window.initCollectionPagination?.();

          // Ensure product images are visible
          setTimeout(() => {
            const productBlocks = document.querySelectorAll('.main-collection__products .product-card');
            productBlocks.forEach(block => {
              const img = block.querySelector('.product-card__image-wrapper img');
              if (!img || img.complete) {
                block.classList.add('main-image-loaded');
              } else {
                img.addEventListener('load', () => block.classList.add('main-image-loaded'));
                img.addEventListener('error', () => block.classList.add('main-image-loaded'));
              }
            });
          }, 0);
        }

        const newDescription = doc.querySelector('.main-collection__description');
        const currentDescription = document.querySelector('.main-collection__description');
        if (newDescription && currentDescription) {
          currentDescription.replaceWith(newDescription);
        } else if (newDescription) {
          const title = document.querySelector('.main-collection__title');
          if (title) title.insertAdjacentElement('afterend', newDescription);
        } else if (currentDescription) {
          currentDescription.remove();
        }

        applyClientSideFilters();
      })
      .catch(err => {
        console.error('Filter Error:', err);
        window.location.href = url;
      })
      .finally(() => {
        if (productsContainer) {
          productsContainer.classList.remove('loading');
        }
      });
  }

  // Update active filter count
  function updateActiveFilterCount() {
    let count = filterForm.querySelectorAll('input[type="checkbox"]:checked').length;

    // Check if price range is active
    const minInput = filterForm.querySelector('.input-min');
    const maxInput = filterForm.querySelector('.input-max');
    if (minInput && maxInput) {
      const minValue = parseInt(minInput.value) || 0;
      const maxValue = parseInt(maxInput.value) || parseInt(maxInput.getAttribute('max')) || 10000;
      const defaultMin = parseInt(minInput.getAttribute('min')) || 0;
      const defaultMax = parseInt(maxInput.getAttribute('max')) || 10000;

      // Count price as active if either min or max differs from default
      if (minValue > defaultMin || maxValue < defaultMax) {
        count++;
      }
    }

    const filterCountBubble = document.querySelector('.active-filter-count-bubble');
    if (filterCountBubble) {
      filterCountBubble.textContent = count > 0 ? `(${count})` : '';
      filterCountBubble.style.display = count > 0 ? '' : 'none';
    }
  }

  syncFiltersFromUrl();
  window.initCollectionPagination?.();
  applyClientSideFilters();

  // Initialize filter count on page load
  updateActiveFilterCount();

  // Initialize price range sliders
  initPriceRangeSliders();

  // Debounce utility
  function debounce(fn, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const debouncedFilter = debounce(() => {
    handleProductFilter();
  }, 300);

  function initPriceRangeSliders() {
    const priceRangeGroups = filterForm.querySelectorAll('.filter-group-display__price-slider');

    priceRangeGroups.forEach(group => {
      const rangeMin = group.querySelector('.range-min');
      const rangeMax = group.querySelector('.range-max');
      const inputMin = group.querySelector('.input-min');
      const inputMax = group.querySelector('.input-max');
      const progress = group.querySelector('.slider .progress');

      if (!rangeMin || !rangeMax || !inputMin || !inputMax || !progress) return;

      // Set initial progress position
      setProgressPosition();

      // Sync range sliders with number inputs
      rangeMin.addEventListener('input', () => {
        const minVal = parseInt(rangeMin.value);
        const maxVal = parseInt(rangeMax.value);
        const gap = 1;

        if (maxVal - minVal < gap) {
          rangeMin.value = maxVal - gap;
        }

        inputMin.value = rangeMin.value;
        setProgressPosition();
        updateActiveFilterCount();
        debouncedFilter();
      });

      rangeMax.addEventListener('input', () => {
        const minVal = parseInt(rangeMin.value);
        const maxVal = parseInt(rangeMax.value);
        const gap = 1;

        if (maxVal - minVal < gap) {
          rangeMax.value = minVal + gap;
        }

        inputMax.value = rangeMax.value;
        setProgressPosition();
        updateActiveFilterCount();
        debouncedFilter();
      });

      // Sync number inputs with range sliders
      inputMin.addEventListener('input', () => {
        let minPrice = parseInt(inputMin.value) || 0;
        const maxPrice = parseInt(inputMax.value) || parseInt(rangeMax.max);
        const minAllowed = parseInt(rangeMin.min) || 0;
        const gap = 1;

        if (minPrice < minAllowed) {
          minPrice = minAllowed;
          inputMin.value = minPrice;
        } else if (minPrice > maxPrice - gap) {
          minPrice = maxPrice - gap;
          inputMin.value = minPrice;
        }

        rangeMin.value = minPrice;
        setProgressPosition();
        updateActiveFilterCount();
      });

      inputMax.addEventListener('input', () => {
        let maxPrice = parseInt(inputMax.value) || parseInt(rangeMax.max);
        const minPrice = parseInt(inputMin.value) || 0;
        const maxAllowed = parseInt(rangeMax.max) || 10000;
        const gap = 1;

        if (maxPrice > maxAllowed) {
          maxPrice = maxAllowed;
          inputMax.value = maxPrice;
        } else if (maxPrice < minPrice + gap) {
          maxPrice = minPrice + gap;
          inputMax.value = maxPrice;
        }

        rangeMax.value = maxPrice;
        setProgressPosition();
        updateActiveFilterCount();
      });

      // Trigger filter on blur for number inputs
      inputMin.addEventListener('blur', () => {
        handleProductFilter();
      });

      inputMax.addEventListener('blur', () => {
        handleProductFilter();
      });

      function setProgressPosition() {
        const minVal = parseInt(rangeMin.value);
        const maxVal = parseInt(rangeMax.value);
        const maxRange = parseInt(rangeMax.max) || 10000;

        const leftPercent = (minVal / maxRange) * 100;
        const rightPercent = 100 - (maxVal / maxRange) * 100;

        progress.style.left = `${leftPercent}%`;
        progress.style.right = `${rightPercent}%`;
      }
    });
  }

  // Reset filters
  if (resetFiltersButton) {
    resetFiltersButton.addEventListener('click', (event) => {
      event.preventDefault();
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.checked = false;
      });

      // Reset price range
      const minInput = filterForm.querySelector('.input-min');
      const maxInput = filterForm.querySelector('.input-max');
      const rangeMin = filterForm.querySelector('.range-min');
      const rangeMax = filterForm.querySelector('.range-max');
      const progress = filterForm.querySelector('.slider .progress');

      if (minInput && maxInput) {
        const defaultMin = minInput.getAttribute('min') || '0';
        const defaultMax = maxInput.getAttribute('max') || '10000';
        minInput.value = defaultMin;
        maxInput.value = defaultMax;
        if (rangeMin) rangeMin.value = defaultMin;
        if (rangeMax) rangeMax.value = defaultMax;
        if (progress) {
          progress.style.left = '0%';
          progress.style.right = '0%';
        }
      }

      handleProductFilter();
      updateActiveFilterCount();
    });
  }
});
